import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";

import Spinner from "../../../../shared/components/spinner/spinner";
import TextInput from "../../../../shared/components/text-input/text-input";
import AuthContext from "../../../../shared/context/auth-context";
import { IEnumerationOption } from "../../../../shared/definitions/datatypes";
import useHttp from "../../../../shared/hooks/use-http";
import { getAllData } from "../../../../shared/utils/api";
import { IObject, validateLoadingStatusNew } from "../../../../shared/utils/utils";
import SearchInput from "../../../components/search-input/search-input";

export interface IScreenSetupData {
  name: string;
  entity: string;
  entity_id: string;
}

interface IScreenSetupConfig {
  screenData: IScreenSetupData;
  handleDataChange: (newData: IScreenSetupData) => void;
}

const ScreenSetup = ({screenData, handleDataChange}: IScreenSetupConfig) => {
  const authCtx = useContext(AuthContext);
  const params = useParams();

  const [data, setData] = useState<IScreenSetupData>({
    name: "",
    entity: "",
    entity_id: ""
  });

  const [allEntities, setAllEntities] = useState<IEnumerationOption[]>([]);

  const { sendRequest: getAllEntities, status: getAllEntitiesStatus, data: allEntitiesData, error: getAllEntitiesError } = useHttp(getAllData, false, authCtx.token, undefined, "manager");

  useEffect(() => {
    if (allEntitiesData && !getAllEntitiesError && getAllEntitiesStatus === "completed") {
      setAllEntities(allEntitiesData.rows.map((row: IObject) => ({
        id: row.id,
        name: row.name
      })));
    }
  }, [allEntitiesData, getAllEntitiesStatus, getAllEntitiesError]);

  useEffect(() => {
    if (!params.id) {
      getAllEntities("available_datamodels/entity");
    }
  }, []);

  useEffect(() => {
    if (params.id && screenData.entity_id) {
      setAllEntities([{
        id: screenData.entity_id,
        name: screenData.entity
      }]);
    }
  }, [screenData]);

  useEffect(() => {
    setData(screenData);
  }, [screenData]);

  const handleOnNameChange = (newValue: string) => {
    data.name = newValue;
    setData({...data});
    handleDataChange({...data});
  };

  const handleOnEntitySelect = (selectedEntity: IEnumerationOption | undefined) => {
    if (!selectedEntity) {
      data.entity = "";
      data.entity_id = "";
    } else {
      data.entity = selectedEntity.name;
      data.entity_id = selectedEntity.id;
    }
    
    setData({...data});
    handleDataChange({...data});
  };

  return <div>
    {validateLoadingStatusNew([getAllEntitiesStatus]) && <Spinner />}
    <div className="captureScreen-nameInput">
      <TextInput
        type={"text"}
        id={"name"}
        label={"Screen Name"}
        autofocus={false}
        required={true}
        inputKey={"Input_field_name"}
        handleOnChange={handleOnNameChange}
        controlled={true}
        value={data.name}
      />
    </div>
    <div className="entityDropdown">
    
      {<SearchInput
        label={"Entity"}
        handleOnChange={handleOnEntitySelect}
        data={allEntities}
        selectedOption={data.entity_id}
        inputKey="entity"
        required={true}
        readonly={!!params.id}
      />}
    </div>
  </div>;
};

export default ScreenSetup;